import * as React from 'react';
import {Avatar, Box, Card, Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';
import axios from '../../axios';
import {useDarkMode} from '../darkMode/hook/useDarkMode';

const AvatarProfile = ({size, showName}) => {
  const {profil} = useUserInfo();
  const navigate = useNavigate();
  const {mode} = useDarkMode();

  return profil ? (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      id={'profilAvatar'}>
      <Avatar
        onClick={() => navigate('/profile')}
        sx={{width: size, height: size, cursor: 'pointer'}}
        src={`${axios.defaults.apiBaseURL}/${profil.image}`}
        aria-label={'Photo de profil'}
      />
      {showName && (
        <Typography variant={'subtitle1'} color={mode.settings.textColor3}>
          {profil.first_name} {profil.last_name}
        </Typography>
      )}
    </Stack>
  ) : (
    <div></div>
  );
};

export default AvatarProfile;
